import { IPaths } from "~/types/routing";

export const paths: IPaths = {
  index: "/background-remover",
};
